import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import ganttboard from './store/ganttboard.js';
export default new Vuex.Store({
	modules: {
		ganttboard,
	},
})
